import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag is available
    if (typeof window.gtag !== 'undefined') {
      // Send page view event to GA4
      window.gtag('config', 'G-ZX3V1JHFVC', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
};
